import type { NoContainerResolverContext } from '@source-components-react/types';
import { resolveEnclosingTag } from './resolve-enclosing-tag';

/**
 * True when RText is about to render an element that can carry a className —
 * any enclosing tag, block or inline. Bare text has no element, so false.
 *
 * Shares `resolveEnclosingTag` with RText and `resolveNoContainer`: if this
 * disagreed with what the component renders, a class would either land on
 * nothing or force a redundant wrapper.
 */
export const resolveRendersOwnElement = ({
  componentAttributes,
}: NoContainerResolverContext): boolean => !!resolveEnclosingTag(componentAttributes);
